/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { assert } from '@ember/debug';
import config from 'cio/config/environment';
import { dropTask, timeout } from 'ember-concurrency';
import ignorePromiseFailure from 'cio/utils/ignore-promise-failure';
import SegmentModel from 'cio/models/segment';

const RELOAD_INTERVAL = config.APP.segmentReloadInterval;

interface CioSegmentProgressArgs {
  segment: SegmentModel;
}

export default class CioSegmentProgress extends Component<CioSegmentProgressArgs> {
  constructor(owner: unknown, args: CioSegmentProgressArgs) {
    super(owner, args);
    assert('[component:cio-segment-progress] "segment" is required', args.segment);
    this.reloadSegment.perform();
  }

  private reloadSegment = dropTask(async () => {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      await this.args.segment.reload().catch(ignorePromiseFailure);
      await timeout(RELOAD_INTERVAL);
    }
  });
}
